import { configureStore } from '@reduxjs/toolkit';
import mastersReducer from 'features/masters/mastersSlice';
import commonReducer from 'features/common/commonSlice';
import dashboardReducer from 'features/dashboard/dashboardSlice';
import measuresReducer from 'features/measures/measuresSlice';
import devicesReducer from 'features/devices/devicesSlice';
import patientsReducer from 'features/patients/patientsSlice';
import userDetailReducer from 'features/userDetail/userDetailSlice';
import deviceDetailReducer from 'features/deviceDetail/deviceDetailSlice';
import relativesReducer from 'features/relatives/relativesSlice';
import relativeDetailReducer from 'features/relativeDetail/relativeDetailSlice';
import warehousesReducer from 'features/warehouses/warehousesSlice';
import warehouseDetailReducer from 'features/warehouseDetail/warehouseDetailSlice';
import professionalsReducer from 'features/professionals/professionalsSlice';
import medicationsReducer from 'features/vademecumMedications/medicationsSlice';
import professionalDetailReducer from 'features/professionalDetail/professionalDetailSlice';
import groupsReducer from 'features/groups/groupsSlice';
import groupDetailReducer from 'features/groupDetail/groupDetailSlice';
import alarmQueueReducer from 'features/alarmQueue/alarmQueueSlice';
import expedientQueueReducer from 'features/expedientQueue/expedientQueueSlice';
import expedientsSearchReducer from 'features/expedientsSearch/expedientsSearchSlice';
import aiNotesReducer from 'features/aiNotes/aiNotesSlice';
import filtersReducer from 'features/filters/filtersSlice';
import settingsReducer from 'features/settings/settingsSlice';
import alarmReducer from 'features/alarm/alarmSlice';
import agendaReducer from 'features/agendas/agendasSlice';
import thinfinityReducer from 'features/thinfinity/thinfinitySlice';
import pathologiesReducer from 'features/icdPathologies/pathologiesSlice';
import classifierTypesReducer from 'features/classifierTypes/classifierTypesSlice';
import userClassifierReducer from 'features/userClassifier/userClassifierSlice';
import classifierReducer from 'features/classifiers/classifierSlice'
import deviceTypesReducer from 'features/deviceTypes/deviceTypesSlice';
import notificationsReducer from 'features/notifications/notificationsSlice';
import errorLogsReducer from 'features/errorLogs/errorLogsSlice';
import billingReducer from 'features/billing/billingSlice';
import catalogTranslationsReducer from 'features/catalogTranslations/catalogTranslationsSlice';
import resiplusIntegrationReducer from 'features/resiplusIntegration/resiplusIntegrationSlice';
import uiVisibilityReducer from 'features/uiVisibility/uiVisibilitySlice';
import systemStatusReducer from 'features/systemStatus/systemStatusSlice';
import notMeasuredSettingsReducer from 'features/notMeasuredSettings/notMeasuredSettingsSlice';
import peripheralProcessingReducer from 'features/peripheralProcessing/peripheralProcessingSlice';
import fieldLabelsReducer from 'features/fieldLabels/fieldLabelsSlice';
import groupLogoReducer from 'features/groupLogo/groupLogoSlice';
import releaseNotesReducer from 'features/releaseNotes/releaseNotesSlice';
import expedientFollowReducer from 'features/expedientFollow/expedientFollowSlice';
import { alarmQueuePollingListener } from "../features/alarmQueue/alarmQueuePollingListener";
import { errorNotificationMiddleware } from 'features/notifications/errorNotificationMiddleware';
import { thunkTraceMiddleware } from 'features/performance/thunkTraceMiddleware';

export const store = configureStore({
  reducer: {
    masters: mastersReducer,
    common: commonReducer,
    alarms: alarmReducer,
    agendas: agendaReducer,
    dashboard: dashboardReducer,
    measures: measuresReducer,
    devices: devicesReducer,
    patients: patientsReducer,
    userDetail: userDetailReducer,
    deviceDetail: deviceDetailReducer,
    relatives: relativesReducer,
    relativeDetail: relativeDetailReducer,
    warehouses: warehousesReducer,
    warehouseDetail: warehouseDetailReducer,
    professionals: professionalsReducer,
    professionalDetail: professionalDetailReducer,
    groups: groupsReducer,
    groupDetail: groupDetailReducer,
    alarmQueue: alarmQueueReducer,
    expedientQueue: expedientQueueReducer,
    expedientsSearch: expedientsSearchReducer,
    aiNotes: aiNotesReducer,
    filters: filtersReducer,
    settings: settingsReducer,
    thinfinity: thinfinityReducer,
    medications: medicationsReducer,
    pathologies: pathologiesReducer,
    classifierTypes: classifierTypesReducer,
    classifier: classifierReducer,
    userClassifier: userClassifierReducer,
    deviceTypes: deviceTypesReducer,
    notifications: notificationsReducer,
    errorLogs: errorLogsReducer,
    billing: billingReducer,
    catalogTranslations: catalogTranslationsReducer,
    resiplusIntegration: resiplusIntegrationReducer,
    uiVisibility: uiVisibilityReducer,
    systemStatus: systemStatusReducer,
    notMeasuredSettings: notMeasuredSettingsReducer,
    peripheralProcessing: peripheralProcessingReducer,
    fieldLabels: fieldLabelsReducer,
    groupLogo: groupLogoReducer,
    releaseNotes: releaseNotesReducer,
    expedientFollow: expedientFollowReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(alarmQueuePollingListener.middleware)
      .concat(errorNotificationMiddleware, thunkTraceMiddleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;